import React from 'react';

import _ from "lodash";
import cx from "classnames";
import styles from '../fields.module.scss';
import { Sortable } from "@shopify/draggable";
import { Fragment } from 'react';

export default function ListFieldOption({ handleChange, handleDelete, selection }) {

  return (
    <Fragment>
      {selection && selection.options.length == 0 && <EmptyMessage />}

      {selection &&
        selection.options.map((option) => {
          return <Option option={option} onDelete={(option) => handleDelete(option)} handleChange={(e, option) => handleChange(e, option)} sortable={Sortable} selection={selection} />
        })
      }
    </Fragment>
  )
}

const Option = ({ option, onDelete, handleChange }) => {
  return (
    <div className={cx(styles.option, 'cs-draggable-item')} key={option.id}>
      <div className={styles.value}>
        <span className={cx(styles.dragHandle, 'cs-drag')}>
          <i className={cx('cleverstory-drag')} />
        </span>
        <input className={styles.name} key={option.id} value={option.value} onChange={(e) => handleChange(e, option)} />
        <i className={'cleverstory-trash'} onClick={() => onDelete(option)} />
      </div>
    </div>
  )
}

const EmptyMessage = () => {
  return (
    <div className={styles.emptyMessage}>Add Values to the List</div>
  )
}